const AUTH_ROUTES = {
  LOGIN: "agency/manager/login",
  LOGOUT: "auth/user/logout",
  UPDATE_TOKEN: "auth/user/update-device-token",
  FORGOT_PASSWORD: "agency/manager/forgot-password",
  RESET_PASSWORD: "agency/manager/reset-password",
  CHANGE_PASSWORD: "agency/manager/change-password",
};

const DASHBOARD_ROUTES = {
  FETCH_PROFILE: "agency/manager/profile",
  UPDATE_IMAGE: "agency/profile/image",
  MAILING_ADDRESS: "agency/bank/mail-address",
  BANK_KYC: "agency/bank/kyc",
  OPEN_ACCOUNT: "agency/bank/open-account",
  DASH_STATISTIC_CARDS: "agency/dashboard/statistics",
  FACILITY_POSITIONS: (start_date, end_date) =>
    `agency/dashboard/${start_date}/${end_date}/`,
  STATISTIC_DATA: (start_date, end_date) =>
    `agency/dashboard/${start_date}/${end_date}/stats/`,
  WEEKDAY_OPENINGS: (start_date, end_date) =>
    `agency/dashboard/${start_date}/${end_date}/weekly-openings/`,
  POSITION_DETAILS: (schedule_id, position_id) =>
    `agency/shifts/${schedule_id}/info?position_id=${position_id}`,
  POSITION_STATS_DETAIL: (schedule_id, position_id) =>
    `agency/shifts/${schedule_id}/openings?position_id=${position_id}`,
  APPLICANT_LISTING: (schedule_id, urlParams) =>
    `agency/shifts/${schedule_id}/employees?${urlParams}`,
  APPLICANT_STATUS_UPDATE: (schedule_id, applicant_id) =>
    `agency/shifts/${schedule_id}/applicants/${applicant_id}`,
  MODAL_STATS: (type, start_date, end_date, urlParams) =>
    `agency/dashboard/${start_date}/${end_date}/stats/${type}/?${urlParams}`,
};
//Added agnecy routes not to update profile of manger from
//Agency details, need to confirm it with team.

const AGENCY_ROUTES = {
  UPDATE_AGENCY: "agency/profile",
  FETCH_ADDRESS: "agency/profile",
  DELETE_AGENCY_IMAGE: "agency/profile/images/",
  AGENCY_KYC: "agency/bank/kyc",
  AGENCY_KYC_ADDRESS: "agency/bank/mail-address",
  AGNECY_OPEN_ACCOUNT: "agency/bank/open-account",
  AGENCY_BANK: "agency/bank",
  LOCATION_PREFERENCES: "agency/location-preferences",
};

const MANAGER_ROUTES = {
  UPDATE_PROFILE: `agency/manager/profile`,
};

const DISCPLINE_DEPARTMENT = {
  DISCIPLINE: "facilities/disciplines",
  DEPARTMENT: "facilities/departments",
  UNIT: "facilities/unit",
  FETCH_ALL_DISCIPLINES: "facilities/disciplines-list",
  FETCH_ALL_DEPARTMENTS: "facilities/departments-list",
};
const W2 = {
  FORMDATA: (id, id2) => `/facilities/employees/${id}/w2form/${id2}`,
};
const NURSE_MGMT = {
  FECTH_NURSES: `agency/employees`,
  FETCH_CREDENTIALS: (employeeId) =>
    `agency/employees/${employeeId}/credentials`,
  PATCH_CREDENTIALS: (employeeId, credID) =>
    `agency/employees/${employeeId}/credentials/${credID}`,
  PATCH_EXPIRY: (employeeId, credID) =>
    `agency/employees/${employeeId}/credentials/${credID}/expiry`,
  POST_PROFILE_PHOTO: (employeeId) =>
    `agency/employees/${employeeId}/profile-photo`,
  ADD_EMPLOYEE: `agency/employees`,
  EDIT_EMPLOYEE_DETAILS: (employeeId) => `agency/employees/${employeeId}`,
  PATCH_CREDENTIAL_STATUS: (employeeId, credID) =>
    `agency/employees/${employeeId}/credentials/${credID}/action`,
  FETCH_JOB_TITLES: "common/job-titles",
  NURSE_STATUS: `agency/employees/action`,
  NURSE_WORK_HISTORY: (employeeId) =>
    `agency/employees/${employeeId}/work-history`,
  INVITE_NURSE_MANUALLY: "agency/employees/bulk/invite-manually",
};

const WORK_DATA = {
  JOB_CATEGORIES: `/common/labor-categories-with-titles`,
  LABOUR_CATEGORIES: (jobCat) =>
    `/common/labor-categories/job-titles/${jobCat}/`,
  FETCH_STATES: (countryID) => `/common/state/${countryID}`,
  FETCH_FACILITIES: `/common/facilities`,
};

const COMMON_API = {
  CHECK_EMAIL: (email) => `common/check-email/${email}`,
  CHECK_MOBILE: (mobile) => `common/check-mobile/+1/${mobile}`,
  Facility_LIST: (date) => `agency/dashboard/${date}/${date}/facility-list/`,
};

const SHIFT_EXPLORE = {
  FACILITIES_OPENINGS: (date) => `agency/shifts/explore/${date}`,
  FAVORITE_FACILITY: (facilityID) =>
    `agency/facilities/${facilityID}/preference`,
  ALL_POSITIONS: (shiftDate, facilityID) =>
    `agency/shifts/explore/${shiftDate}/facility/${facilityID}`,
  PUBLISH_OPENING: (positionID) =>
    `agency/shifts/explore/${positionID}/publish`,
  INTERESTED_SHIFTS: (shiftDate) => `agency/shifts/published/${shiftDate}`,
  ALL_PUBLISH_POSITIONS: (shiftDate, facilityID) =>
    `agency/shifts/published/${shiftDate}/facility/${facilityID}`,
  SHIFT_DETAILS: (shiftID) => `agency/shifts/${shiftID}/info`,
  SHIFT_OPENINGS: (shiftID) => `agency/shifts/${shiftID}/openings`,
  AVAILABLE_NURSES: (agencyShiftID) =>
    `agency/shifts/${agencyShiftID}/available-employees`,
  ASSIGN_NURSES: (agencyShiftID) =>
    `agency/shifts/${agencyShiftID}/assign-employees`,
  GET_ASSIGNED_NURSES: (shiftID) => `agency/shifts/${shiftID}/employees`,
  EDIT_PAY_RATE: (agencyShiftID) => `agency/shifts/${agencyShiftID}`,
  AVAILABLE_EMPLOYEESE: (agencyShiftID) =>
    `agency/shifts/${agencyShiftID}/employees`,
  //There are difference between shift ID and agency shift id.
  //(Agency shift id belongs to that perticular position in which agency interested)
};

const PAYROLL_MANAGMENT = {
  PAYMENT_RUNPAYROLL: `agency/payments/run-payroll`,
  PAYMENT_DETAILS: (id) => `agency/payments/detail/${id}`,
  PAYROLL_HISTORY: (date) => `agency/payroll-history/${date}`,
  EXPORT_PAYROLL_HISTORY: (date) => `agency/payroll-history/${date}/export`,
  PAYROLL_HISTORY_DETAILS: (date) => `agency/payroll-history/details/${date}`,
  EXPORT_PAYROLL_HISTORY_DETAILS: (date) =>
    `agency/payroll-history/details/${date}/export`,
  REFRESH_PAYROLL: "/agency/run-tax-job",
  PAYMENT_RUNPAYROLL_EXPORT: (status) =>
    `agency/payments/run-payroll/export?status=${status}`,
};

const MESSAGE = {
  MESSAGE_TOKEN: "agency/message-center/access-token",
  CREATE_CONVERSATION: "agency/message-center/conversation",
};

const INVOICES = {
  REFRESH_INVOICES: "agency/invoices/refresh",
  INVOICE_LISTING: "agency/invoices",
  INVOICE_DETAILS: (Id) => `agency/invoices/${Id}`,
  DELETE_INVOICE: (invoice_id) => `agency/invoices/${invoice_id}`,
  SEND_INVOICE: (invoice_id) => `/agency/invoices/action/${invoice_id}`,
  API_TO_EXPORT: `agency/invoices/export`,
};

const MANUAL_INVOICES = {
  FACILITY_LISTING: "agency/invoices/facility",
  RESOURCE_LISTING: (facilityID) =>
    `agency/invoices/facility/${facilityID}/nurses`,
  WORKED_JOB_TITLES: (facilityID, nurseID) =>
    `/agency/invoices/facility/${facilityID}/nurses/${nurseID}/job_title`,
  AGGREGATE_WORK_RECORDS: (facilityID, nurseID, jobTitleID) =>
    `agency/invoices/facility/${facilityID}/nurses/${nurseID}/job_title/${jobTitleID}`,
  GENRATE_INVOICE: `/agency/invoices/manual`,
};

const AGENCY_FUND_ACCOUNT = {
  AGENCY_FUND_ACCOUNT: "agency/bank/fund-account",
  AGENCY_FUND_DEPOSIT: "agency/bank/fund-account/micro-deposit",
};

const VAULT_STATS = {
  VAULT_BAL: `agency/bank/vault`,
  VAULT_STAT: `agency/bank/vault/deposit`,
};

const EMPLOYEE_SCHEDULE = {
  FECTH_NURSES: "agency/employees",
  FETCH_ASSIGNED_SHIFTS: (employee_id, start_date, end_date) =>
    `agency/employees/${employee_id}/schedule/${start_date}/${end_date}`,
  CHECK_SHIFTS: (employee_id, start_date, end_date) =>
    `agency/employees/${employee_id}/check-exists/${start_date}/${end_date}`,
  GET_AVAILABLE_SCHEDULE: (employee_id, shift_date) =>
    `agency/employees/${employee_id}/available-schedule/${shift_date}`,
  ASSIGN_SHIFT: (employee_id) => `agency/employees/${employee_id}/assign-shift`,
  UNASSIGN_SHIFT: (employee_id) =>
    `agency/employees/${employee_id}/withdraw-shift`,
};

const REIMBURSE_ROUTE = {
  FACILITY_LISTING: "agency/invoices/facility",
  REIMBURSE_LIST: "agency/reimbursement",
  EXPENSE_CATEGORY: "common/expense-category",
  MANUAL_REIMBURSEMENT: "agency/reimbursement/manual",
  REIMBURSEMENT_ACTION: "agency/reimbursement/action",
};

const BULK_INVITE = {
  VALIDATE_CSV: "agency/employees/bulk/validate",
  BULK_INVITE: "/agency/employees/bulk/invite",
};

const DEFAULT_RATE = {
  GET_RATES: `agency/default-rate`,
  PATCH_RATES: (id) => `agency/default-rate/${id}`,
};

const ROLL_MANAGEMENT = {
  GET_RATES: `agency/default-rate`,
  PATCH_RATES: (id) => `agency/default-rate/${id}`,
};
const SETTINGS_ROUTES = {
  CREDENTIALS_LIST: "agency/manage-credentials",
  CREDENTIALS_DETAILS: "agency/configure-credentials",
  UPDATE_CREDENTIAL: "agency/configure-credentials",
};

const ENDPOINTS = {
  ...AUTH_ROUTES,
  ...DISCPLINE_DEPARTMENT,
  ...DASHBOARD_ROUTES,
  ...NURSE_MGMT,
  ...WORK_DATA,
  ...COMMON_API,
  ...SHIFT_EXPLORE,
  ...MESSAGE,
  ...AGENCY_ROUTES,
  ...MANAGER_ROUTES,
  ...PAYROLL_MANAGMENT,
  ...INVOICES,
  ...EMPLOYEE_SCHEDULE,
  ...AGENCY_FUND_ACCOUNT,
  ...VAULT_STATS,
  ...MANUAL_INVOICES,
  ...REIMBURSE_ROUTE,
  ...BULK_INVITE,
  ...DEFAULT_RATE,
  ...SETTINGS_ROUTES,
};
export { ENDPOINTS };
